const ReportTemplateGroupCalculation = (data) => {
  const { group_data, group_label, key, list_data, report_type } = data;

  let count = 0;
  for (let data of list_data) {
    const { speedo_akhir, km_warning, next, last } = data;

    const kmWarningAll = km_warning + last;
    let isWarning = speedo_akhir >= kmWarningAll && speedo_akhir < next;
    let isDanger = speedo_akhir >= next;

    if (next <= 0) {
      isWarning = false;
      isDanger = false;
    }

    if (isWarning || isDanger) {
      count++;
    }
  }
  data.group_count = count;

  return data;
};

export default ReportTemplateGroupCalculation;
